module.exports = __webpack_public_path__ + "static/img/z3.96b6686f.png";